import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=297cc266&scoped=true"
import script from "./ItemGrid.vue?vue&type=script&lang=js"
export * from "./ItemGrid.vue?vue&type=script&lang=js"
import style0 from "./ItemGrid.vue?vue&type=style&index=0&id=297cc266&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297cc266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297cc266')) {
      api.createRecord('297cc266', component.options)
    } else {
      api.reload('297cc266', component.options)
    }
    module.hot.accept("./ItemGrid.vue?vue&type=template&id=297cc266&scoped=true", function () {
      api.rerender('297cc266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/browser/ItemGrid.vue"
export default component.exports